export default "/_next/static/images/my-decor-modal-b9c8f4df5ea377d79277bbc06061b27f.png";